class FetchAuditEntries {
	constructor(
		public readonly accountId: number,
		// Already composed by the `AuditTrailFilterView` (`page`, `rows`, `actorUserId`, `action`,
		// `outcome`, `resourceType`, `resourceId`, `facilityId`, `beneficiaryId`, `occurredBetween`,
		// `orderByOccurredAt`) — this Query does not know the filter shape.
		public readonly queryParams: URLSearchParams,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}
}

export default FetchAuditEntries;
